import { Component } from 'react';

export class NotStartedStatusSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid={this.props['data-testid']}
                fill="none"
                width="20px"
                height="20px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
            >
                <g clipPath="url(#clip0)">
                    <circle
                        cx="10"
                        cy="10"
                        r="7"
                        stroke="#ADC8D7"
                        strokeWidth="2"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <path d="M0 0h20v20H0V0z" fill="#fff" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
